import ManagerMarket from './ManagerMarket.container';

export default ManagerMarket;
